module.exports = __webpack_public_path__ + "img/shansuan-qrcode.78f9140b.png";